import React from "react";

export default function Hero() {
  return (
    <div className="hero">
      <h1 className="hero-title">Shorten Your Links, Expand Your Reach</h1>
      <p className="hero-subtitle">
        ShortU helps you shorten long URLs and create memorable links for
        your business, social media, and marketing campaigns.
      </p>
    </div>
  );
}
